const labels = {
  translations: {
    navbar: {
      home: "Início",
      tools: "Ferramentas",
      language: "Idioma",
      social: "Social",
      articles: {
        title: "Artigos",
        article_01: {
          title: "Crie seu app de chat por vídeo com Webrtc",
          url: "https://dev.to/cesarpaulomp/crie-seu-app-de-video-chat-com-webrtc-1jea",
        },
        article_02: {
          title: "Crie seu servidor de Live privado",
          url: "https://dev.to/cesarpaulomp/crie-seu-servidor-de-live-privado-part1-1g2g",
        },
        article_03: {
          title:
            "Gerando Thumbnails com NODEJS, FFMPEG, AWS Lambda e Terraform",
          url: "https://dev.to/cesarpaulomp/gerando-thumbnails-com-nodejs-ffmpeg-aws-lambda-e-terraform-2j00",
        },
      },
    },
    home: {
      highlights: "Destaque",
      carousel: {
        looper: {
          about: "Saiba mais",
        },
      },
      about: {
        title: `Sobre o studio`,
        description: `O Unipig é um studio independente que tem como objetivo criar jogos divertidos, em diferentes dispositivos, para todos os momentos.`,
        what_is_a_unipig: `O que é um "Unipig"?`,
        unipig_description: `É uma poderosíssima quimera criada pelo mago Hugo, the Oldest. 
        Esta criatura tem o poder da "irresistibilidade", ou seja, nenhum indivíduo vivo é capaz de resistir ao seu charme.
        E é por isso que, ao temer tamanho poder, Hugo deixou sua criatura aqui no studio e fugiu para outro universo.`,
      },
      contact: {
        title: `Precisa falar com a gente?`,
      },
    },
    policy: {
      title: "Política de Privacidade",
    },
    game: {
      blocknator: {
        policy: {
          description:
            "Os serviços do aplicativo Blocknator são fornecidos pela pessoa física com o seguinte nome: Paulo César Medeiros Porto, inscrito sob o CPF nº 09777223684, titular da propriedade intelectual sobre o software, website, aplicativos, conteúdos e demais ativos relacionados à plataforma Blocknator.",
          personal_data: "1. Dados pessoais e outros dados sensíveis",
          personal_data_desc_01:
            "Nós não coletamos, armazenamos ou compartilhamos dados pessoais ou outros dados sensíveis que pertencem àqueles que utilizam nosso aplicativo.",
          personal_data_desc_02:
            "Nós não nos responsabilizamos por qualquer dano gerado às pessoas que adquirirem cópias ilegais do aplicativo.",
          policy_update: "2. Alterações nesta política",
          policy_update_desc_01:
            "A presente versão desta Política de Privacidade foi atualizada pela última vez em: 11/04/2024.",
          policy_update_desc_02:
            "Reservamo-nos o direito de modificar, a qualquer momento, as presentes normas, especialmente para adaptá-las às eventuais alterações feitas em nosso aplicativo, seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação daquelas já existentes.",
          contact: "3. Como entrar em contato conosco",
          contact_desc_01:
            "Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade, entre em contato com o e-mail: ",
        },
      },
    },
  },
};
export default labels;
